<script setup>
import { onMounted, ref } from 'vue'
import { api } from '../services/api'
import { store } from '../store'

const profile = ref(null)
const form = ref({ full_name: '', grade: 6 })
const error = ref('')
const message = ref('')
const saving = ref(false)
const passwordSaving = ref(false)
const passwordForm = ref({ current_password: '', new_password: '', confirm_password: '' })
const passwordMessage = ref('')
const passwordError = ref('')

onMounted(async () => {
  try {
    profile.value = await api('/profile')
    form.value = { full_name: profile.value.user.full_name, grade: profile.value.user.grade || 6 }
  } catch (err) { error.value = err.message }
})

async function save() {
  saving.value = true
  error.value = ''
  message.value = ''
  try {
    const data = await api('/profile', { method: 'PUT', body: JSON.stringify(form.value) })
    store.user = data.user
    profile.value.user = data.user
    message.value = data.message
  } catch (err) { error.value = err.message }
  finally { saving.value = false }
}

async function changePassword() {
  passwordError.value = ''
  passwordMessage.value = ''
  if (passwordForm.value.new_password !== passwordForm.value.confirm_password) {
    passwordError.value = 'Hai lần nhập mật khẩu mới chưa trùng nhau.'
    return
  }
  passwordSaving.value = true
  try {
    const data = await api('/auth/change-password', { method: 'POST', body: JSON.stringify(passwordForm.value) })
    passwordMessage.value = data.message
    passwordForm.value = { current_password: '', new_password: '', confirm_password: '' }
  } catch (err) { passwordError.value = err.message }
  finally { passwordSaving.value = false }
}

</script>

<template>
  <header class="page-heading-row"><div><p class="eyebrow">Tài khoản của tôi</p><h1 class="page-title">Hồ sơ cá nhân</h1><p class="page-subtitle">Thông tin được dùng để cá nhân hóa lộ trình và báo cáo học tập.</p></div></header>
  <div v-if="error" class="error-banner" style="margin-top:20px">{{ error }}</div>
  <div v-if="!profile && !error" class="loading-block"><div><div class="loader"></div><p>Đang tải hồ sơ…</p></div></div>
  <div v-else-if="profile" class="profile-grid">
    <aside class="card profile-summary"><div class="profile-avatar">{{ profile.user.avatar }}</div><h2>{{ profile.user.full_name }}</h2><p>{{ profile.user.email }}</p><span class="chip">{{ profile.user.role === 'student' ? 'Học sinh' : profile.user.role === 'parent' ? 'Phụ huynh' : 'Quản trị viên' }}</span><div class="profile-details"><div><span>Lớp đang học</span><b>{{ profile.user.grade ? `Lớp ${profile.user.grade}` : '—' }}</b></div><div><span>Tham gia</span><b>{{ new Date(profile.created_at).toLocaleDateString('vi-VN') }}</b></div></div></aside>
    <div class="profile-forms"><form class="card profile-form" @submit.prevent="save"><h2>Thông tin cơ bản</h2><p>Cập nhật tên hiển thị và lớp đang học.</p><div v-if="message" class="success-banner" role="status">{{ message }}</div><div class="form-group"><label>Họ và tên</label><input v-model="form.full_name" class="form-control" minlength="2" required></div><div class="form-group"><label>Email đăng nhập</label><input :value="profile.user.email" class="form-control" disabled></div><div v-if="profile.user.role === 'student'" class="form-group"><label>Lớp đang học</label><select v-model.number="form.grade" class="form-control"><option v-for="grade in 12" :key="grade" :value="grade">Lớp {{ grade }}</option></select></div><button class="btn btn-primary" :disabled="saving">{{ saving ? 'Đang lưu…' : 'Lưu thay đổi' }}</button></form><form class="card profile-form" @submit.prevent="changePassword"><h2>Đổi mật khẩu</h2><p>Chọn mật khẩu mới có ít nhất 8 ký tự.</p><div v-if="passwordError" class="form-error" role="alert">{{ passwordError }}</div><div v-if="passwordMessage" class="success-banner" role="status">{{ passwordMessage }}</div><div class="form-group"><label for="current-password">Mật khẩu hiện tại</label><input id="current-password" v-model="passwordForm.current_password" class="form-control" type="password" required autocomplete="current-password"></div><div class="form-group"><label for="new-password">Mật khẩu mới</label><input id="new-password" v-model="passwordForm.new_password" class="form-control" type="password" required minlength="8" autocomplete="new-password"></div><div class="form-group"><label for="confirm-password">Nhập lại mật khẩu mới</label><input id="confirm-password" v-model="passwordForm.confirm_password" class="form-control" type="password" required minlength="8" autocomplete="new-password"></div><button class="btn btn-primary" :disabled="passwordSaving">{{ passwordSaving ? 'Đang đổi…' : 'Đổi mật khẩu' }}</button></form></div>
  </div>
</template>
